import { defineStore } from "pinia";
import { instance } from "..";
import { TypeAlert, useAlertStore } from "./alert";
import { useAdaptCourseStore } from "./adapt-course";
import { useAdaptMaterialStore } from "./adapt-material";
import { useLearningObjectiveStore } from "./learning-objective";
import { useAdaptQuizStore } from "./adapt-quiz";


export enum StatusProgress {
  INIT_COURSE = "INIT_COURSE",
  INIT_CHAPTER = "INIT_CHAPTER",
  CONTINUE_CHAPTER = "CONTINUE_CHAPTER",
  INIT_OBJECTIVE = "INIT_OBJECTIVE",
  INITTIED_OBJECTIVE = "INITTIED_OBJECTIVE",
  OBJECTIVE_FINISHED = "OBJECTIVE_FINISHED",
  INIT_QUIZ = "INIT_QUIZ",
  QUIZ = "QUIZ",
  QUIZ_APROVED = "QUIZ_APROVED",
  FINISHED_COURSE = "FINISHED_COURSE",
  CERTIFICATE = "CERTIFICATE",
}

export const store = defineStore({
  id: "adapt-progress",
  state: () => ({
    status: StatusProgress.INIT_COURSE,
  }),
  actions: {
    setNextState() {
      const chains = [
        {
          canHandle: (status: StatusProgress) =>
            status === StatusProgress.INIT_COURSE,

          handle: () => {
            useAlertStore?.setCurrentAlert(TypeAlert.INTRO_COURSE, true);
            if (useAdaptCourseStore?.course?.hasStarted) {
              useAdaptProgressStore.status = StatusProgress.INIT_CHAPTER;
            }
            if (useAdaptCourseStore?.course?.done) {
              useAdaptProgressStore.status = StatusProgress.FINISHED_COURSE;
              useAlertStore?.setCurrentAlert(TypeAlert.END, true);
            }
          },
        },
        {
          canHandle: (status: StatusProgress) =>
            status === StatusProgress.INIT_CHAPTER,

          handle: () => {
            if (useAdaptMaterialStore.hasStarted) {
              useAlertStore?.setCurrentAlert(TypeAlert.CONTINUE, true);
            } else {
              useAlertStore?.setCurrentAlert(TypeAlert.INTRO_CHAPTER, true);
            }
          },
        },
        {
          canHandle: (status: StatusProgress) =>
            status === StatusProgress.INIT_OBJECTIVE,
          handle: async () => {
            if (useLearningObjectiveStore.hasFinished) {
              useAdaptQuizStore?.returnQuestionsByQuiz();
              await useAdaptQuizStore?.getQuizByLearningObject();
              useAdaptProgressStore.status = StatusProgress.QUIZ;
              useAlertStore?.setCurrentAlert(TypeAlert.QUIZ, true);
            }
          },
        },
        {
          canHandle: (status: StatusProgress) => status === StatusProgress.QUIZ,
          handle: () => {
            if (useAlertStore?.type === TypeAlert.QUIZ_INIT) {
              useAdaptProgressStore.status = StatusProgress.INIT_QUIZ;
            }
          },
        },
        {
          canHandle: (status: StatusProgress) =>
            status === StatusProgress.INIT_QUIZ,
          handle: () => {
            if (
              useAdaptQuizStore?.quizHasEnded &&
              useAdaptQuizStore?.isApproved
            ) {
              useAlertStore.show = false;
              useAdaptProgressStore.status = StatusProgress.QUIZ_APROVED;
            }
          },
        },
        {
          canHandle: (status: StatusProgress) =>
            status === StatusProgress.QUIZ_APROVED,
          handle: () => {
            if (useAdaptCourseStore?.course?.done) {
              useAdaptProgressStore.status = StatusProgress.FINISHED_COURSE;
              useAlertStore?.setCurrentAlert(TypeAlert.END, true);
            }
          },
        },
        {
          canHandle: (status: StatusProgress) =>
            status === StatusProgress.FINISHED_COURSE,
          handle: () => {
            if (!useAdaptCourseStore?.hasCertificate) {
              useAlertStore?.setCurrentAlert(TypeAlert.NO_CERTIFICATE, true);
            } else {
              useAlertStore?.setCurrentAlert(TypeAlert.END, true);
            }
          },
        },
      ];

      for (const chain of chains) {
        if (chain.canHandle(this.status)) {
          chain.handle();
        }
      }
    },
  },
  getters: {
    currentStatus: (state) => state.status,
    isCourseFinished: (state) =>
      state.status === StatusProgress.FINISHED_COURSE,
    isCertificateAvailable: (state) =>
      state.status === StatusProgress.CERTIFICATE,
  },
});

export const useAdaptProgressStore = store(instance);
